import React from "react";
import { Input, Radio, Button, Space } from "antd";

const { Search } = Input;

const TeamFilters = ({ onSearch, onFilterChange, onRefresh, loading }) => (
  <Space wrap>
    <Search
      placeholder="Search team members..."
      onChange={(e) => onSearch(e.target.value)}
      allowClear
    />

    <Radio.Group onChange={onFilterChange} defaultValue="all">
      <Radio.Button value="all">All</Radio.Button>
      <Radio.Button value="active">Active</Radio.Button>
      <Radio.Button value="inactive">Inactive</Radio.Button>
    </Radio.Group>

    <Button onClick={onRefresh} loading={loading}>
      Refresh
    </Button>
  </Space>
);

export default TeamFilters;
